import React, { useState, useEffect, useContext, use } from 'react';
import {
  Container, Box, TextField, Button, Dialog, Autocomplete, DialogContent,
  DialogTitle, Grid, MenuItem, IconButton, InputAdornment, DialogActions,
  Tooltip, Typography, Table, TableBody, TableCell, ListItemIcon, ListItemText,
  TableContainer, TableHead, TableRow, Paper, FormControl, Select, Stack, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox
} from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import axios from 'axios';
import * as XLSX from 'xlsx';
import ReusableTable from '../components/tables/resuabletable';
import { AuthContext } from '..';
import jsPDF from 'jspdf';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import format from 'date-fns/format';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';
import MailOutlineIcon from '@mui/icons-material/MailOutline'

import autoTable from 'jspdf-autotable'



export default function ClientsPage() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [services, setServices] = useState([]);
  const [leadCompanies, setLeadCompanies] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [pdf, setPdf] = useState(true);
  const { companyid, companydata, preferredPaymentData, paymentTermsData, permissions, selfOnly, employeeId, token } = useContext(AuthContext);
  const [employeelist, setEmployeelist] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLeadSelected, setIsLeadSelected] = useState(false);
  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);



  const [appliedFilters, setAppliedFilters] = useState([]);
  const [openfailureDialog, setOpenfailureDialog] = useState(false);
  const [failures, setFailures] = useState([]);
  const [tab, setTab] = useState({ value: '1' });
  const [invoicedialog, setInvoicedialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [opencolspaper, setOpencolspaper] = useState(false);
  const [columnOrder, setColumnOrder] = useState([]);
  const [negotiate, setNegotiate] = useState('No');
  const [newDiscount, setNewDiscount] = useState(0);
  const [selectedLeadDiscount, setSelectedLeadDiscount] = useState(0);
  const [taxOption, setTaxOption] = useState('including');
  const [roundOff, setRoundOff] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [formData, setFormData] = useState({
    companyid: '',
    clientName: '', contactPerson: '', email: '', phone: '', alternateContact: '',
    taxId: '', streetAddress: '', city: '', state: '', postalCode: '', country: '',
    discount: '', amountToPay: '', assignedTo: '', paymentTerms: '',
    preferredPayment: '', notes: '',
    negotiate: 'No',
    taxOption: 'including',
    roundOff: null,
    original_taxableAmount: 0,
    original_taxAmount: 0,
    original_totalAmount: 0,
    revised_taxableAmount: 0,
    revised_taxAmount: 0,
    revised_totalAmount: 0,
    revisedAmounts: []
  });
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [emailSubject, setEmailSubject] = useState('');
  const [emailContent, setEmailContent] = useState('');


  const getLeadButtonLabel = (editingclientid, tab) => {
    if (!editingclientid) return "Submit Client";
    if (tab == 1) return "Update Client";
    if (tab == 2) return "Make Active";
    if (tab == 3) return "Make Client";
    return "Update Client";
  };

  const filteredColumns = columnOrder
    .map(field => columns.find(col => col.field === field))
    .filter(col => col && !col.hide);

  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 25,
  });
  const [totalrows, setTotalrows] = useState(0);

  const handlePaginationChange = (paginationData) => {
    setPagination(paginationData);
  };

  const computeAmounts = () => {
    let subtotal = 0;
    let taxAmount = 0;
    let totalAmount = 0;

    selectedServices.forEach(service => {
      const serviceAmounts = calculateServiceAmount(service);
      subtotal += parseFloat(serviceAmounts.baseAmount);
      taxAmount += parseFloat(serviceAmounts.taxAmount);
      totalAmount += parseFloat(serviceAmounts.totalAmount);
    });

    const discountPct = parseFloat(negotiate === 'Yes' ? newDiscount : selectedLeadDiscount) || 0;
    const discountAmount = parseFloat(totalAmount * (discountPct / 100));
    const totalAfterDiscount = parseFloat(totalAmount - discountAmount);

    const originalTaxable = parseFloat(subtotal);
    const originalTax = parseFloat(taxAmount);
    const originalTotal = parseFloat(totalAmount);

    let revisedTaxable = originalTaxable;
    let revisedTax = originalTax;
    let revisedTotal = totalAfterDiscount;

    if (negotiate === 'Yes' && formData.roundOff > 0) {
      const taxPercentage = parseFloat((originalTax / originalTaxable || 0) * 100);
      if (taxOption === 'including') {
        revisedTaxable = parseFloat(formData.roundOff / (1 + (taxPercentage / 100)) || 1);
        revisedTax = parseFloat(formData.roundOff - revisedTaxable);
        revisedTotal = parseFloat(formData.roundOff);
      } else {
        revisedTax = parseFloat(formData.roundOff * (taxPercentage / 100));
        revisedTotal = parseFloat(formData.roundOff + revisedTax);
        revisedTaxable = parseFloat(formData.roundOff);
      }
    }

    const revisedAmountsArray = [
      { description: 'Original Total Amount', amount: originalTotal.toFixed(2) },
      { description: 'Original Taxable Amount', amount: originalTaxable.toFixed(2) },
      { description: 'Original Tax Amount', amount: originalTax.toFixed(2) },
      { description: 'Tax Percentage', amount: `${((originalTax / originalTaxable || 0) * 100).toFixed(2)}%` },
      { description: 'Revised Base Amount', amount: revisedTaxable.toFixed(2) },
      { description: 'Revised Tax Amount', amount: revisedTax.toFixed(2) },
      { description: 'Final Total Amount', amount: revisedTotal }
    ];

    return {
      original_taxableAmount: originalTaxable,
      original_taxAmount: originalTax,
      original_totalAmount: originalTotal,
      revised_taxableAmount: revisedTaxable,
      revised_taxAmount: revisedTax,
      revised_totalAmount: revisedTotal,
      revisedAmounts: revisedAmountsArray
    };
  };

  useEffect(() => {
    if (selectedServices.length > 0) {
      const amounts = computeAmounts();
      setFormData(prev => ({
        ...prev,
        ...amounts,
        roundOff: prev.roundOff
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        original_taxableAmount: 0,
        original_taxAmount: 0,
        original_totalAmount: 0,
        revised_taxableAmount: 0,
        revised_taxAmount: 0,
        revised_totalAmount: 0,
        revisedAmounts: [],
        discount: 0,
        roundOff: prev.roundOff
      }));
    }
  }, [selectedServices, negotiate, newDiscount, selectedLeadDiscount, taxOption, formData.roundOff]);



  const validate = () => {
    const newErrors = {};
    if (!formData.clientName) newErrors.clientName = "Client name is required";
    if (!formData.contactPerson) newErrors.contactPerson = "Contact person is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone is required";
    if (!formData.streetAddress) newErrors.streetAddress = "Address is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";
    if (!formData.postalCode) newErrors.postalCode = "Postal code is required";

    selectedServices.forEach((service, index) => {
      if (!service.start_date) {
        newErrors[`serviceStartDate_${index}`] = "Start date is required";
      }
      if (!service.end_date) {
        newErrors[`serviceEndDate_${index}`] = "End date is required";
      }
      if (service.start_date && service.end_date && new Date(service.end_date) < new Date(service.start_date)) {
        newErrors[`serviceEndDate_${index}`] = "End date must be after start date";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (tab.value == 3) {
      setPdf(false)
    }
    else {
      setPdf(true)
    }
    if (tab.value == 2) {
      setDeleteicon(false)
    }
    else {
      setDeleteicon(true)
    }
  }, [tab])

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      companyid: companyid,
    }));
    refreshClients();
    fetchServices();
    fetchLeadCompanies();
    roles();
    refreshData();
  }, [tab, appliedFilters, pagination]);

  useEffect(() => {
    if (negotiate === 'Yes' && newDiscount === 0) {
      setNewDiscount(selectedLeadDiscount);
      setFormData(prev => ({
        ...prev,
        discount: selectedLeadDiscount
      }));
    } else if (negotiate === 'No') {
      setFormData(prev => ({
        ...prev,
        discount: selectedLeadDiscount
      }));
    }
  }, [negotiate, selectedLeadDiscount]);

  const getCountryId = (countryName) => {
    if (!countryName) return '';
    return countries.find(
      c => c.name?.toLowerCase() === countryName.toLowerCase()
    )?.id || '';
  };

  const getStateId = (stateName) => {
    if (!stateName) return '';
    return states.find(
      s => s.name?.toLowerCase() === stateName.toLowerCase()
    )?.id || '';
  };

  const getCityId = (cityName) => {
    if (!cityName) return '';
    return cities.find(
      c => c.name?.toLowerCase() === cityName.toLowerCase()
    )?.id || '';
  };

  const finalFollowup = (leadid) => {
    const selectedLead = leadCompanies.find(lead => lead.id === leadid);
    if (!selectedLead) {
      Swal.fire('Error', 'Selected lead not found.', 'error');
      setIsLeadSelected(false);
      setSelectedServices([]);
      setFormData(prev => ({
        ...prev,
        leadid: leadid,
        companyid: companyid,
        clientName: '',
        contactPerson: '',
        email: '',
        phone: '',
        alternateContact: '',
        streetAddress: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        assignedTo: '',
        notes: '',
        discount: '',
        amountToPay: '',
        paymentTerms: '',
        preferredPayment: '',
        negotiate: 'No',
        taxOption: 'including',
        roundOff: null,
        original_taxableAmount: 0,
        original_taxAmount: 0,
        original_totalAmount: 0,
        revised_taxableAmount: 0,
        revised_taxAmount: 0,
        revised_totalAmount: 0,
        revisedAmounts: []
      }));
      return;
    }

    axios.get(`${process.env.REACT_APP_API_LINKS}/followups/finalfollowup/${leadid}`, {
      headers:
      {
        Authorization: `bearer ${token}`
      }, withCredentials: true
    })
      .then((res) => {
        const followUpData = res.data[0];
        if (!followUpData || !followUpData.services) {

          let parsedLeadServices = [];
          try {
            if (typeof selectedLead.services === 'string') {
              parsedLeadServices = JSON.parse(selectedLead.services);
            } else if (Array.isArray(selectedLead.services)) {
              parsedLeadServices = selectedLead.services;
            } else {
              console.warn('Lead services data is not in expected format:', selectedLead.services);
              parsedLeadServices = [];
            }
          } catch (error) {
            console.error('Failed to parse lead services:', error);
            parsedLeadServices = [];
          }

          const formattedLeadServices = parsedLeadServices.map(service => ({
            id: service.id,
            service_name: service.service_name,
            original_duration: service.original_duration || service.duration,
            duration: service.duration,
            base_price: service.base_price,
            tax_rate: service.tax_rate,
            total_amount: parseFloat(service.total_amount || service.base_price).toFixed(2),
            start_date: service.start_date ? new Date(service.start_date.includes('T') ? service.start_date : `${service.start_date}T00:00:00`) : null,
            end_date: service.end_date ? new Date(service.end_date.includes('T') ? service.end_date : `${service.end_date}T00:00:00`) : null,
          }));
          const countryId = getCountryId(selectedLead.country);
          const stateId = getStateId(selectedLead.state);
          const cityId = getCityId(selectedLead.city);


          setSelectedServices(formattedLeadServices);
          setIsLeadSelected(false);
          setFormData(prev => ({
            ...prev,
            leadid: leadid,
            companyid: companyid,
            clientName: selectedLead.lead_name || '',
            contactPerson: selectedLead.full_name || '',
            email: selectedLead.email || '',
            phone: selectedLead.phone || '',
            alternateContact: selectedLead.alternate_number || '',
            streetAddress: selectedLead.address || '',
            country: countryId,
            state: stateId,
            city: cityId,
            postalCode: selectedLead.zip_code || '',
            assignedTo: selectedLead.assigned_to || '',
            notes: selectedLead.notes || '',
            discount: selectedLead.discount || '',
            amountToPay: formattedLeadServices.length > 0
              ? formattedLeadServices.reduce((sum, s) => sum + parseFloat(s.total_amount), 0) * (1 - (parseFloat(selectedLead.discount || 0) / 100)).toFixed(2)
              : '',
            paymentTerms: '',
            preferredPayment: '',
            negotiate: 'No',
            taxOption: 'including',
            roundOff: null,
            original_taxableAmount: 0,
            original_taxAmount: 0,
            original_totalAmount: 0,
            revised_taxableAmount: 0,
            revised_taxAmount: 0,
            revised_totalAmount: 0,
            revisedAmounts: []
          }));
          setNegotiate('No');
          setTaxOption('including');
          setRoundOff(0);
          setNewDiscount(0);
          setSelectedLeadDiscount(0);
          return;
        }

        let parsedServices = [];
        try {
          if (typeof followUpData.services === 'string') {
            parsedServices = JSON.parse(followUpData.services);
          } else if (Array.isArray(followUpData.services)) {
            parsedServices = followUpData.services;
          } else {
            console.warn('Services data is not in expected format:', followUpData.services);
            parsedServices = [];
          }
        } catch (error) {
          console.error('Failed to parse services from finalFollowup:', error);
          parsedServices = [];
        }

        const formattedServices = parsedServices.map(service => ({
          id: service.id,
          service_name: service.service_name,
          original_duration: service.original_duration,
          duration: service.duration,
          base_price: service.base_price,
          tax_rate: service.tax_rate,
          total_amount: parseFloat(service.total_amount).toFixed(2),
          start_date: service.start_date ? new Date(service.start_date.includes('T') ? service.start_date : `${service.start_date}T00:00:00`) : null,
          end_date: service.end_date ? new Date(service.end_date.includes('T') ? service.end_date : `${service.end_date}T00:00:00`) : null,
        }));
        const countryId = getCountryId(selectedLead.country);
        const stateId = getStateId(selectedLead.state);
        const cityId = getCityId(selectedLead.city);


        const originalTaxable = followUpData.original_taxableAmount || 0;
        const originalTax = followUpData.original_taxAmount || 0;
        const originalTotal = followUpData.original_totalAmount || 0;
        const revisedTaxable = followUpData.revised_taxableAmount || 0;
        const revisedTax = followUpData.revised_taxAmount || 0;
        const revisedTotal = followUpData.revised_totalAmount || 0;

        setSelectedServices(formattedServices);
        setIsLeadSelected(true);

        setFormData(prev => ({
          ...prev,
          companyid: companyid,
          clientName: selectedLead.lead_name || '',
          contactPerson: selectedLead.full_name || '',
          email: selectedLead.email || '',
          phone: selectedLead.phone || '',
          alternateContact: selectedLead.alternate_number || '',
          streetAddress: selectedLead.address || '',
          country: countryId,
          state: stateId,
          city: cityId,
          postalCode: selectedLead.zip_code || '',
          // country: selectedLead.country_id || '',
          assignedTo: followUpData.assignedTo || selectedLead.assigned_to || '',
          notes: followUpData.notes || selectedLead.notes || '',
          discount: followUpData.discount || selectedLead.discount || '',
          amountToPay: revisedTotal,
          paymentTerms: '',
          preferredPayment: '',
          negotiate: followUpData.negotiate || 'No',
          taxOption: followUpData.taxOption || 'including',
          roundOff: followUpData.roundOff || 0,
          original_taxableAmount: originalTaxable,
          original_taxAmount: originalTax,
          original_totalAmount: originalTotal,
          revised_taxableAmount: revisedTaxable,
          revised_taxAmount: revisedTax,
          revised_totalAmount: revisedTotal,
          services: formattedServices
        }));
        setNegotiate(followUpData.negotiate || 'No');
        setTaxOption(followUpData.taxOption || 'including');
        setRoundOff(followUpData.roundOff || 0);
        setNewDiscount(followUpData.discount || 0);
        setSelectedLeadDiscount(followUpData.discount || 0);
      })
      .catch(err => {
        console.error('Failed to fetch final followup data:', err);
        // Fallback to lead data if API fails
        let parsedLeadServices = [];
        try {
          if (typeof selectedLead.services === 'string') {
            parsedLeadServices = JSON.parse(selectedLead.services);
          } else if (Array.isArray(selectedLead.services)) {
            parsedLeadServices = selectedLead.services;
          } else {
            console.warn('Lead services data is not in expected format:', selectedLead.services);
            parsedLeadServices = [];
          }
        } catch (error) {
          console.error('Failed to parse lead services:', error);
          parsedLeadServices = [];
        }

        const formattedLeadServices = parsedLeadServices.map(service => ({
          id: service.id,
          service_name: service.service_name,
          original_duration: service.original_duration || service.duration,
          duration: service.duration,
          base_price: service.base_price,
          tax_rate: service.tax_rate,
          total_amount: parseFloat(service.total_amount || service.base_price).toFixed(2),
          start_date: service.start_date ? new Date(service.start_date.includes('T') ? service.start_date : `${service.start_date}T00:00:00`) : null,
          end_date: service.end_date ? new Date(service.end_date.includes('T') ? service.end_date : `${service.end_date}T00:00:00`) : null,
        }));
        const countryId = getCountryId(selectedLead.country);
        const stateId = getStateId(selectedLead.state);
        const cityId = getCityId(selectedLead.city);


        setSelectedServices(formattedLeadServices);
        setIsLeadSelected(false);
        setFormData(prev => ({
          ...prev,
          companyid: companyid,
          clientName: selectedLead.lead_name || '',
          contactPerson: selectedLead.full_name || '',
          email: selectedLead.email || '',
          phone: selectedLead.phone || '',
          alternateContact: selectedLead.alternate_number || '',
          streetAddress: selectedLead.address || '',
          country: countryId,
          state: stateId,
          city: cityId,
          postalCode: selectedLead.zip_code || '',
          assignedTo: selectedLead.assigned_to || '',
          notes: selectedLead.notes || '',
          discount: selectedLead.discount || '',
          amountToPay: formattedLeadServices.length > 0
            ? formattedLeadServices.reduce((sum, s) => sum + parseFloat(s.total_amount), 0) * (1 - (parseFloat(selectedLead.discount || 0) / 100)).toFixed(2)
            : '',
          paymentTerms: '',
          preferredPayment: '',
          negotiate: 'No',
          taxOption: 'including',
          roundOff: null,
          original_taxableAmount: 0,
          original_taxAmount: 0,
          original_totalAmount: 0,
          revised_taxableAmount: 0,
          revised_taxAmount: 0,
          revised_totalAmount: 0,
          services: formattedLeadServices
        }));
        setNegotiate('No');
        setTaxOption('including');
        setRoundOff(0);
        setNewDiscount(0);
        setSelectedLeadDiscount(0);
        Swal.fire('Warning', 'No follow-up data found. Using lead data instead.', 'warning');
      });
  };

  const refreshData = () => {
    if (!companyid) return;

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/countries`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    })
      .then(res => setCountries(res.data))
      .catch(err => console.error('Failed to fetch countries:', err));

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/states`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => setStates(res.data))
      .catch(err => console.error('Failed to fetch states:', err));

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/cities`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => setCities(res.data))
      .catch(err => console.error('Failed to fetch cities:', err));
  };

  const fetchLeadCompanies = () => {
    const payload = {
      module: true,
      selfOnly: selfOnly,
      employeeid: employeeId
    }
    axios.get(`${process.env.REACT_APP_API_LINKS}/leads/getcompanyleads/${companyid}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: payload, withCredentials: true
    })
      .then((res) => {
        const leads = res.data.data || [];
        const validLeads = leads.filter(lead => lead.lead_name && lead.conversion_status != 0);
        setLeadCompanies(validLeads);
      });
  };

  const roles = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/employees/getemployees`, {
      headers: {
        Authorization: `bearer ${token}`
      },
      withCredentials: true
    })
      .then((res) => {
        setEmployeelist(res.data.data);
      })
      .catch((error) => {
        console.error('Error fetching employees:', error);
      });
  };

  const refreshClients = () => {

    const payload =
    {
      tab: tab.value,
      filters: JSON.stringify(appliedFilters),
      currentpage: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      selfOnly: selfOnly,
      employeeid: employeeId

    }

    axios.get(`${process.env.REACT_APP_API_LINKS}/clients/getclients/${companyid}`, { params: payload, withCredentials: true, headers: { Authorization: `barer ${token}` } })
      .then(res => {
        const newColumns = res.data.columns.map((col) => {
          if (col.field === "created_at") return { ...col, field: "display_created_at" };
          if (col.field === "updated_at") return { ...col, field: "display_updated_at" };
          return col;
        });
        setColumns(newColumns);
        setColumnOrder(newColumns.filter(col => !col.hide).map(col => col.field));

        const rawRows = res.data.data || [];
        const formattedRows = rawRows.map(row => ({
          ...row,
          services: typeof row.services === 'string'
            ? JSON.parse(row.services || '[]')
            : Array.isArray(row.services)
              ? row.services
              : [],
          display_created_at: row.created_at ? format(new Date(row.created_at), 'dd/MM/yyyy') : '',
          display_updated_at: row.updated_at ? format(new Date(row.updated_at), 'dd/MM/yyyy') : ''
        }));
        setRows(formattedRows);
        const numberofclients = res.data.totalrows[0];
        setTotalrows(numberofclients.totalusers);
      })
      .catch(err => {
        console.error("Failed to fetch clients:", err);
        setRows([]);
      });
  };
  const filteredClients = rows
    .filter((client) => {
      const query = searchQuery.toLowerCase();

      const clientName = client.clientName?.toLowerCase() || '';
      const contactPerson = client.contactPerson?.toLowerCase() || '';
      const email = client.email?.toLowerCase() || '';
      const phone = client.phone?.toLowerCase() || '';
      const alternateContact = client.alternateContact?.toLowerCase() || '';
      const streetAddress = client.streetAddress?.toLowerCase() || '';
      const city = client.city?.toLowerCase() || '';
      const state = client.state?.toLowerCase() || '';
      const postalCode = client.postalCode?.toLowerCase() || '';
      const country = client.country?.toLowerCase() || '';
      const assignedTo = client.assignedTo?.toLowerCase() || '';
      const notes = client.notes?.toLowerCase() || '';
      const paymentTerms = client.paymentTerms?.toLowerCase() || '';
      const preferredPayment = client.preferredPayment?.toLowerCase() || '';
      const negotiate = client.negotiate?.toLowerCase() || '';
      const taxOption = client.taxOption?.toLowerCase() || '';



      return (
        clientName.includes(query) ||
        contactPerson.includes(query) ||
        email.includes(query) ||
        phone.includes(query) ||
        alternateContact.includes(query) ||
        streetAddress.includes(query) ||
        city.includes(query) ||
        state.includes(query) ||
        postalCode.includes(query) ||
        country.includes(query) ||
        assignedTo.includes(query) ||
        notes.includes(query) ||
        paymentTerms.includes(query) ||
        preferredPayment.includes(query) ||
        negotiate.includes(query) ||
        taxOption.includes(query)
      );
    })
    .map((client) => {
      const filteredClient = { ...client };
      filteredColumns.forEach((col) => {
        filteredClient[col.field] = client[col.field] || '';
      });
      return filteredClient;
    });
  const formatClientsData = (clients) => {
    return clients.map((client, index) => {
      const formattedClient = { S_No: index + 1 };

      filteredColumns.forEach((col) => {
        if (col.headerName === 'S.No') return;

        formattedClient[col.headerName || col.field] = client[col.field] || '';
      });

      return formattedClient;
    });
  };

  const fetchServices = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/services/getservices`, {
      headers:
      {
        Authorization: `bearer ${token}`
      },
      withCredentials: true
    })
      .then(res => {
        if (Array.isArray(res.data.data)) {
          setServices(res.data.data);
        } else {
          console.error('Service data is not in expected format:', res.data);
          setServices([]);
        }
      })
      .catch(err => {
        console.error('Failed to fetch services:', err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'discount') {
      const discountValue = parseFloat(value) || 0;
      const totalAmount = selectedServices.reduce((sum, service) => sum + parseFloat(service.total_amount), 0);

      if (discountValue > 20) {
        alert('Maximum allowed discount is 20%');
        return;
      }

      const discountedAmount = totalAmount - (totalAmount * discountValue / 100);
      setFormData(prev => ({
        ...prev,
        discount: value,
        amountToPay: isNaN(discountedAmount) ? '' : discountedAmount.toFixed(2)
      }));
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleServiceSelect = (e) => {
    const selectedServiceName = e.target.value;
    const service = services.find(s => s.service_name === selectedServiceName);

    if (service && !selectedServices.some(s => s.service_name === selectedServiceName)) {
      const newService = {
        id: service.id,
        service_name: service.service_name,
        original_duration: service.duration,
        duration: service.duration,
        base_price: service.base_price,
        tax_rate: service.tax_rate,
        total_amount: service.base_price,
        start_date: null,
        end_date: null
      };

      setSelectedServices([...selectedServices, newService]);
    }
  };

  const handleServiceDateChange = (index, field, date) => {
    const updatedServices = [...selectedServices];
    updatedServices[index][field] = date;

    if (field === 'start_date' || field === 'end_date') {
      const service = updatedServices[index];
      if (service.start_date && service.end_date) {
        const startDate = new Date(service.start_date);
        const endDate = new Date(service.end_date);
        const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

        const basePricePerDay = parseFloat(service.base_price) / parseInt(service.original_duration);
        const amount = (basePricePerDay * duration * (1 + (parseFloat(service.tax_rate) / 100))).toFixed(2);

        updatedServices[index].duration = duration;
        updatedServices[index].total_amount = amount;
      }
    }

    setSelectedServices(updatedServices);

    const discount = parseFloat(formData.discount) || 0;
    const amountToPay = updatedServices.reduce((sum, s) => sum + parseFloat(s.total_amount), 0) * (1 - discount / 100);
    setFormData(prev => ({
      ...prev,
      amountToPay: amountToPay.toFixed(2)
    }));
  };

  const removeService = (serviceId) => {
    const updated = selectedServices.filter(service => service.id !== serviceId);
    const discount = parseFloat(formData.discount) || 0;
    const amountToPay = updated.reduce((sum, s) => sum + parseFloat(s.total_amount), 0) * (1 - discount / 100);

    setSelectedServices(updated);
    setFormData(prev => ({
      ...prev,
      amountToPay: amountToPay.toFixed(2)
    }));
  };

  const handleEdit = (client) => {
    const getIdFromValue = (list, value) => {
      const match = list?.find(item => item.value.toLowerCase() === value?.toLowerCase());
      return match ? match.id : '';
    };

    const getEmployeeIdFromName = (name) => {
      const match = employeelist.find(item => item.employee_name.toLowerCase() === name?.toLowerCase());
      return match ? match.id : '';
    };

    const getLocationId = (list, name) => {
      if (!name) return '';
      const match = list.find(item => item.name.toLowerCase() === name.toLowerCase());
      return match ? match.id : '';
    };

    let parsedServices = [];
    try {
      parsedServices = typeof client.services === 'string'
        ? JSON.parse(client.services)
        : Array.isArray(client.services)
          ? client.services
          : [];
    } catch (error) {
      console.error("Failed to parse services:", error);
      parsedServices = [];
    }

    const updatedServices = parsedServices.map(service => {
      const startDate = service.start_date
        ? new Date(service.start_date.includes('T') ? service.start_date : `${service.start_date}T00:00:00`)
        : null;
      const endDate = service.end_date
        ? new Date(service.end_date.includes('T') ? service.end_date : `${service.end_date}T00:00:00`)
        : null;

      const duration = service.duration;
      const original_duration = service.original_duration;
      const totalamount = service.total_amount;

      return {
        ...service,
        original_duration: original_duration,
        start_date: startDate,
        end_date: endDate,
        duration: duration,
        total_amount: totalamount
      };
    });

    const totalAmount = updatedServices.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0);
    const discount = parseFloat(client.discount || 0);
    const amountToPay = totalAmount * (1 - discount / 100).toFixed(2);

    setFormData({
      companyid: companyid,
      clientName: client.client_name || '',
      contactPerson: client.contact_person || '',
      email: client.email || '',
      phone: client.phone || '',
      alternateContact: client.alternate_contact || '',
      taxId: client.tax_id || '',
      streetAddress: client.street_address || '',
      city: getLocationId(cities, client.city),
      state: getLocationId(states, client.state),
      postalCode: client.postal_code || '',
      country: getLocationId(countries, client.country),
      discount: client.discount || '',
      amountToPay: amountToPay,
      assignedTo: getEmployeeIdFromName(client.assigned_to),
      paymentTerms: getIdFromValue(paymentTermsData, client.payment_terms),
      preferredPayment: getIdFromValue(preferredPaymentData, client.preferred_payment),
      notes: client.notes || '',
      negotiate: String(client.negotiate) || client.negotiate || 'No',
      taxOption: 'including',
      roundOff: client.round_off,
      original_taxableAmount: 0,
      original_taxAmount: 0,
      original_totalAmount: 0,
      revised_taxableAmount: 0,
      revised_taxAmount: 0,
      revised_totalAmount: 0,
      revisedAmounts: []
    });

    setSelectedServices(updatedServices);
    setEditingId(client.id);
    setOpenDialog(true);
  };

  const handleSubmit = () => {
    if (!selectedServices.length) {
      return alert("Please select at least one service");
    }
    if (!validate()) {
      return;
    }

    const clientData = {
      ...formData,
      companyid: companyid,
      selectedServices: selectedServices.map(service => ({
        ...service,
        start_date: service.start_date ? format(new Date(service.start_date), 'yyyy-MM-dd') : '',
        end_date: service.end_date ? format(new Date(service.end_date), 'yyyy-MM-dd') : ''
      }))
    };
    const tabid = tab.value;

    const request = editingId
      ? axios.put(`${process.env.REACT_APP_API_LINKS}/clients/updateclient/${editingId}/${tabid}`, clientData, {
        headers:
        {
          Authorization: `bearer ${token}`
        }, withCredentials: true
      })
      : axios.post(`${process.env.REACT_APP_API_LINKS}/clients/addclient`, clientData, {
        headers:
        {
          Authorization: `bearer ${token}`
        }, withCredentials: true
      });

    request.then(() => {
      Swal.fire({
        icon: 'success',
        text: editingId ? 'Client updated successfully' : 'Client added successfully',
        timer: 1500,
        showConfirmButton: false
      });
      setOpenDialog(false);
      setEditingId(null);
      setSelectedServices([]);
      refreshClients();
    }).catch((err) => {
      if (err.status === 409) {
        setOpenDialog(false);
        Swal.fire({
          icon: 'error',
          text: 'Client Email Already Exists',
          timer: 2000,
          showConfirmButton: false
        });
        setEditingId(null);
        setSelectedServices([]);
        refreshClients();

      }
      else {
        Swal.fire({
          icon: 'error',
          text: editingId ? 'Client update failed' : 'Failed to add client',
          timer: 2000,
          showConfirmButton: false
        });
      }
    });
  };

  const formatdate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return format(date, 'dd/MM/yyyy');
  };

  const calculateServiceAmount = (service) => {
    const perDayCost = parseFloat(service.base_price) / parseInt(service.original_duration);

    let taxableAmount = parseFloat(service.base_price); // Default to original amount

    if (service.start_date && service.end_date) {
      const startDate = new Date(service.start_date);
      const endDate = new Date(service.end_date);
      const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
      taxableAmount = perDayCost * duration;
    }

    const taxAmount = taxableAmount * (parseFloat(service.tax_rate) / 100);

    const totalAmount = taxableAmount + taxAmount;

    return {
      baseAmount: taxableAmount.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      totalAmount: totalAmount.toFixed(2)
    };
  };

  const calculateTotalAmount = () => {
    return selectedServices.reduce((sum, service) => sum + parseFloat(service.total_amount), 0).toFixed(2);
  };

  const calculateDiscountedAmount = () => {
    const total = parseFloat(calculateTotalAmount());
    const discount = parseFloat(formData.discount) || 0;
    return (total - (total * discount / 100)).toFixed(2);
  };

  const exportToExcel = () => {
    const exportRows = selectedIds.length > 0
      ? rows.filter(row => selectedIds.includes(row.id))
      : filteredClients;

    const exportData = formatClientsData(exportRows).map(row => {
      const { S_No, Next_Follow_Up_Date, ...rest } = row;
      return rest;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clients');
    XLSX.writeFile(wb, `Clients_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const handleBulkInsert = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

      if (!worksheet.length) {
        return Swal.fire('Error', 'Excel sheet is empty', 'error');
      }
      axios.post(`${process.env.REACT_APP_API_LINKS}/clients/bulkinsert`, {
        clients: worksheet,
        companyid: companyid
      }, {
        headers:
        {
          Authorization: `bearer ${token}`
        }, withCredentials: true
      })
        .then((res) => {
          Swal.fire('Success', 'Bulk clients inserted successfully', 'success');
          refreshClients();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.failures) {
            setFailures(err.response.data.failures);
            setOpenDialog(true);
            console.log('Failed/skipped records:', err.response.data.failures);
          } else {
            Swal.fire('Error', 'Server error occurred', 'error');
            console.error('Bulk insert error:', err.response?.data || err.message);
          }
        });



    };
    reader.readAsArrayBuffer(file);
    refreshClients()
  };

  const handleDelete = (client) => {
    const tabid = tab.value;
    Swal.fire({
      title: `Delete ${client.client_name}?`,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${process.env.REACT_APP_API_LINKS}/clients/deleteclient/${client.id}/${tabid}`,
          {
            headers:
            {
              Authorization: `bearer ${token}`
            }, withCredentials: true
          }
        )
          .then(() => {
            Swal.fire('Deleted!', 'Client has been deleted.', 'success');
            refreshClients();
          })
          .catch(() => {
            Swal.fire('Error!', 'Failed to delete client.', 'error');
          });
      }
    });
  };
  const closemaildialogbox = () => {
    setInvoicedialog(false);
  };
  const maildialogbox = (client) => {
    setSelectedClient(client);

    setInvoicedialog(true);
  };
  const handleSendEmail = () => {
    if (!emailSubject.trim()) {
      Swal.fire('Error', 'Subject is required', 'error');
      return;
    }
    if (!emailContent.trim()) {
      Swal.fire('Error', 'Email content is required', 'error');
      return;
    }
    handlePdf(selectedClient, 'send', emailSubject);
    handleCloseEmailDialog();
  };
  const handleCloseEmailDialog = () => {
    setOpenEmailDialog(false);
    setEmailSubject('');
    setEmailContent('');
    setSelectedClient(null);
  };
  const handleOpenEmailDialog = (client) => {
    setSelectedClient(client);
    setEmailSubject(`Billing  Details for ${client.client_name} - ${new Date().toISOString().split('T')[0]}`);
    setEmailContent(
      `Dear ${client.full_name || client.client_name},\n\n` +
      `We hope this message finds you well. Attached are the details for your Payment Details, including services, dates, and financial summary.\n\n` +
      `Please review the attached PDF for complete details. Feel free to reach out if you have any questions or require further assistance.\n\n` +
      `Best regards,\n${companydata[0]?.companyname || 'Your Company Name'}`
    );
    setOpenEmailDialog(true);
  };


  const handlePdf = async (client, invoiceduty, dynamicSubject) => {
    if (!invoiceduty || invoiceduty === "cancel") return;

    try {
      const bankRes = await axios.get(
        `${process.env.REACT_APP_API_LINKS}/settings/bank-account`,
        {
          headers:
          {
            Authorization: `bearer ${token}`
          },
          withCredentials: true
        }
      );

      const bankData = bankRes.data?.bankData;

      const settingsRes = await axios.get(
        `${process.env.REACT_APP_API_LINKS}/settings/getsettings`,
        {
          headers:
          {
            Authorization: `bearer ${token}`
          },
          withCredentials: true
        }
      );
      if (settingsRes.status !== 200) throw new Error('Failed to fetch company settings');
      const settings = settingsRes.data;

      const services = Array.isArray(client.services) ? client.services : typeof client.services === 'string' ? JSON.parse(client.services) : [];
      const subtotal = services.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0);
      const discount = parseFloat(client.discount || 0);
      const discountAmount = subtotal * (discount / 100);
      const total = client.revised_total_amount || subtotal - discountAmount;

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginX = 20;
      const startY = 50;
      const endY = pageHeight - 40;
      let currentY = startY;

      // const checkAddPage = (blockHeight = 10) => {
      //   if (currentY + blockHeight > endY) {
      //     pdf.addPage();
      //     currentY = startY;
      //     if (bgImage.src) pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
      //   }
      // };

      // // --- Background ---
      // const bgUrl = `${process.env.REACT_APP_API_LINKS}/headers/${settings?.logo || ''}`;
      // const bgImage = new Image();
      // bgImage.crossOrigin = "anonymous";
      // bgImage.src = bgUrl;
      // const bgLoaded = await new Promise((resolve) => {
      //   bgImage.onload = () => resolve(true);
      //   bgImage.onerror = () => resolve(false);
      // });

      // if (bgLoaded) {
      //   pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
      // }
      const checkAddPage = (blockHeight = 10) => {
        if (currentY + blockHeight > endY) {
          pdf.addPage();
          currentY = startY;

          if (bgImage) {
            pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
          } else {
            pdf.setFillColor(255, 255, 255);
            pdf.rect(0, 0, pageWidth, pageHeight, "F");
          }
        }
      };

      // Default white background first
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageWidth, pageHeight, "F");

      let bgImage = null;

      // Only try loading image if logo exists
      if (settings && settings.logo) {
        const bgUrl = `${process.env.REACT_APP_API_LINKS}/headers/${settings.logo}`;

        bgImage = new Image();
        bgImage.crossOrigin = "anonymous";
        bgImage.src = bgUrl;

        const bgLoaded = await new Promise((resolve) => {
          bgImage.onload = () => resolve(true);
          bgImage.onerror = () => resolve(false);
        });

        if (bgLoaded) {
          pdf.addImage(bgImage, "PNG", 0, 0, pageWidth, pageHeight);
        }
      }

      // --- Header ---
      pdf.setFont("Times", "bold");
      pdf.setFontSize(18);
      pdf.text("Invoice", pageWidth / 2, currentY - 10, { align: "center" });

      // --- Dynamic Subject ---
      pdf.setFont("Times", "bold");
      pdf.setFontSize(14);
      const subjectLines = pdf.splitTextToSize(dynamicSubject || `Invoice for ${client.client_name}`, pageWidth - 2 * marginX);
      checkAddPage(subjectLines.length * 6);
      pdf.text(subjectLines, marginX, currentY);
      currentY += subjectLines.length * 6 + 8;

      // --- Client Info ---
      pdf.setFont("Times", "normal");
      pdf.setFontSize(12);
      checkAddPage(30);
      pdf.text(`To: ${client.client_name || ''}`, marginX, currentY);
      pdf.text(`Contact: ${client.contact_person || ''}`, marginX, currentY + 6);
      pdf.text(`Email: ${client.email || ''}`, marginX, currentY + 12);
      pdf.text(`Phone: ${client.phone || ''}`, marginX, currentY + 18);
      pdf.text(`Date: ${new Date().toLocaleDateString()}`, pageWidth - marginX, currentY, { align: 'right' });
      pdf.text(`Status: ${client.status || 'active'}`, pageWidth - marginX, currentY + 6, { align: 'right' });
      currentY += 28;

      // --- Services Table ---
      const tableColumns = ["Service", "Start Date", "End Date", "Days", "Amount"];
      const tableRows = services.map(s => [
        s.service_name || '-',
        s.start_date?.split('T')[0] || '-',
        s.end_date?.split('T')[0] || '-',
        s.duration || '-',
        parseFloat(s.total_amount || 0).toFixed(2)
      ]);

      autoTable(pdf, {
        startY: currentY,
        head: [tableColumns],
        body: tableRows,
        margin: { left: marginX, right: marginX },
        styles: {
          font: "times",
          fontSize: 10,
          textColor: [0, 0, 0],
          cellPadding: 3,
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          overflow: "linebreak",
          fillColor: null
        },
        headStyles: {
          fontStyle: "bold",
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          halign: "center",
          fillColor: null
        },
        alternateRowStyles: {
          fillColor: null
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 30 },
          2: { cellWidth: 30 },
          3: { cellWidth: 20 },
          4: { cellWidth: 35, halign: "right" }
        }
      });
      currentY = pdf.lastAutoTable.finalY + 12;

      // --- Negotiation Details ---
      pdf.setFont("Times", "bold");
      pdf.text("Negotiation Details:", marginX, currentY);
      pdf.setFont("Times", "normal");
      const negotiationLines = [
        `Negotiate: ${client.negotiate || 'No'}`,
        `Tax Option: ${client.tax_option || 'including'}`,
        `Round Off: ${parseFloat(client.round_off || 0).toFixed(2)}`
      ];
      checkAddPage(negotiationLines.length * 6 + 8);
      pdf.text(negotiationLines, marginX, currentY + 6);
      currentY += negotiationLines.length * 6 + 14;

      // --- Financial Summary (if negotiated) ---
      if (client.negotiate === 'Yes') {
        const financialColumns = ["Description", "Amount"];
        const financialRows = [
          ["Original Taxable Amount", parseFloat(client.original_taxable_amount || 0).toFixed(2)],
          ["Tax Amount", parseFloat(client.original_tax_amount || 0).toFixed(2)],
          ["Total Amount", parseFloat(client.original_total_amount || 0).toFixed(2)],
          ["Revised Taxable Amount", parseFloat(client.revised_taxable_amount || 0).toFixed(2)],
          ["Revised Tax Amount", parseFloat(client.revised_tax_amount || 0).toFixed(2)],
          ["Final Total Amount", parseFloat(client.revised_total_amount || 0).toFixed(2)]
        ];
        checkAddPage(60);

        pdf.setFont("Times", "bold");
        pdf.text("Financial Summary:", marginX, currentY);
        currentY += 6;

        autoTable(pdf, {
          startY: currentY,
          head: [financialColumns],
          body: financialRows,
          margin: { left: marginX, right: marginX },
          styles: {
            font: "times",
            fontSize: 10,
            textColor: [0, 0, 0],
            cellPadding: 3,
            lineColor: [0, 0, 0],
            lineWidth: 0.3,
            overflow: "linebreak",
            fillColor: null
          },
          headStyles: {
            fontStyle: "bold",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.3,
            halign: "center",
            fillColor: null
          },
          alternateRowStyles: {
            fillColor: null
          },
          columnStyles: {
            0: { cellWidth: 100 },
            1: { cellWidth: 75, halign: "right" }
          }
        });
        currentY = pdf.lastAutoTable.finalY + 12;
      }

      if (bankData) {
        pdf.setFont("Times", "italic");
        pdf.setFontSize(10);
        const paymentNote = "You can make the payment using the following bank details:";
        checkAddPage(10);
        pdf.text(paymentNote, marginX, currentY);
        currentY += 6;

        pdf.setFont("Times", "normal");
        pdf.setFontSize(10);

        const bankDetailsRows = [
          [`Bank Name: ${bankData.bankName || "-"}`, `A/C Holder: ${bankData.accountHolderName || "-"}`],
          [`A/C Number: ${bankData.accountNumber || "-"}`, `Account Type: ${bankData.accountType || "-"}`],
          [`IFSC: ${bankData.ifscCode || "-"}`, `MICR: ${bankData.micrCode || "-"}`],
          [`Branch Name: ${bankData.branchName || "-"}`, `Branch Address: ${bankData.branchAddress || "-"}`],
        ];

        const rowHeight = 6;
        const columnWidth = (pageWidth - 2 * marginX) / 2;

        for (const row of bankDetailsRows) {
          checkAddPage(rowHeight);
          pdf.text(row[0], marginX, currentY);
          pdf.text(row[1], marginX + columnWidth, currentY);
          currentY += rowHeight;
        }

        currentY += 6;
      }





      // --- Output ---
      const fileName = `Invoice_${client.client_name}_${new Date().toISOString().split('T')[0]}.pdf`;
      if (invoiceduty === "whatsapp") {
        alert('Feature will be added soon');
      } else if (invoiceduty === "download") {
        pdf.save(fileName);
        Swal.fire('Downloaded!', '', 'success');
      } else if (invoiceduty === "preview") {
        window.open(pdf.output("bloburl"), "_blank");
      } else if (invoiceduty === "send") {
        const pdfBlob = pdf.output('blob');
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64PDF = reader.result.split(',')[1];
          const payload = {
            to: client.email || '',
            subject: dynamicSubject || `Invoice Summary - ${client.clientName}`,
            message: emailContent || `\nPlease find the attached summary details.\n\nRegards,\n${companydata[0].companyname}`,
            pdfBase64: base64PDF,
            fileName,
            client,
            services,
            companydata,
            settings
          };
          try {
            const emailRes = await axios.post(
              `${process.env.REACT_APP_API_LINKS}/invoice/sendinvoice`,
              payload,
              {
                headers:
                {
                  Authorization: `bearer ${token}`
                }, withCredentials: true
              }
            );
            if (emailRes.status === 200) {
              Swal.fire('Sent!', 'Invoice has been emailed.', 'success');
            } else {
              Swal.fire('Failed!', 'Could not send email.', 'error');
            }
          } catch (err) {
            Swal.fire('Error!', 'An error occurred sending the email.', 'error');
          }
        };
        reader.readAsDataURL(pdfBlob);
      }
    } catch (err) {
      console.error('PDF generation failed:', err);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  const permissionsaccess = () => {
    const clientsmodule = permissions.clients || {};
    setDeleteicon(clientsmodule.delete === true);
    setEditicon(clientsmodule.update === true);
  };
  useEffect(() => {
    if (permissions && permissions.clients) {
      permissionsaccess();
    }
  }, [permissions]);

  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: 3,
      backgroundColor: '#ffffff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' }
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        gap: 2
      }}>
        {/* Search Box */}
        <TextField
          placeholder="Search by Client Name"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          sx={{
            minWidth: 200,
            width: { xs: '100%', sm: '100%', md: '100%', lg: 400 },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row', },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: { md: 'space-between', sm: 'space-between' },
          gap: 2,
          width: { xs: '100%', sm: '100%', md: '100%', xs: '100%' },
        }}>
          <FormControl size="small" sx={{ width: { lg: 160, md: 400, sm: 400, xs: '100%' } }}>
            <Select
              value={tab.value}
              onChange={(e) => setTab(prev => ({ ...prev, value: e.target.value }))}
              sx={{
                fontSize: '12px',
                '& .MuiSelect-select': {
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 1,
                  fontFamily: 'Open Sans',
                  fontSize: '13px',
                }
              }}
            >
              <MenuItem value="1" sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}>
                <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Active</span>
                <Box sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: "green" }} />
              </MenuItem>
              <MenuItem value="2" sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}>
                <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Inactive</span>
                <Box sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: "red" }} />
              </MenuItem>
              <MenuItem value="3" sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}>
                <span style={{ fontFamily: 'Open Sans', fontSize: "13px" }}>Draft</span>
                <Box sx={{ width: 10, height: 10, borderRadius: "50%", backgroundColor: "yellow" }} />
              </MenuItem>
            </Select>
          </FormControl>

          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'row', sm: 'row' },
            gap: { xs: 1, sm: 2 },
            width: { xs: '100%', md: '100%', sm: '100%' },
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}>
            {permissions?.clients?.create && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  setFormData({
                    clientName: '', contactPerson: '', email: '', phone: '', alternateContact: '',
                    taxId: '', streetAddress: '', city: '', state: '', postalCode: '', country: '',
                    discount: '', amountToPay: '', assignedTo: '',
                    paymentTerms: '', preferredPayment: '', notes: '',
                    negotiate: 'No',
                    taxOption: 'including',
                    roundOff: null,
                    original_taxableAmount: 0,
                    original_taxAmount: 0,
                    original_totalAmount: 0,
                    revised_taxableAmount: 0,
                    revised_taxAmount: 0,
                    revised_totalAmount: 0,
                    revisedAmounts: []
                  });
                  setSelectedServices([]);
                  setEditingId(null);
                  setOpenDialog(true);
                  setIsLeadSelected(false);
                  setNegotiate('No');
                  setTaxOption('including');
                  setRoundOff(0);
                  setNewDiscount(0);
                  setSelectedLeadDiscount(0);
                }}
                sx={{
                  backgroundColor: '#0b85c8',
                  width: { xs: '100%', sm: 'auto' },
                  whiteSpace: 'nowrap',
                  fontFamily: 'Open Sans',
                  borderRadius: 2
                }}
              >
                Add Client
              </Button>
            )}

            <Tooltip title="Export to Excel" arrow>
              <IconButton onClick={exportToExcel} sx={{ color: '#0b85c8' }}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Bulk Insert from Excel" arrow>
              <label htmlFor="bulk-insert">
                <IconButton component="span" sx={{ color: '#0b85c8' }}>
                  <CloudUploadIcon />
                </IconButton>
              </label>
            </Tooltip>
            <input
              type="file"
              accept=".xlsx, .xls"
              style={{ display: 'none' }}
              id="bulk-insert"
              onChange={handleBulkInsert}
            />
            <Tooltip title="Customize Columns" arrow>
              <IconButton
                onClick={() => setOpencolspaper(true)}
                sx={{ color: '#0b85c8', padding: '8px' }}
              >
                <ViewColumnIcon />
              </IconButton>
            </Tooltip>
            {opencolspaper && (
              <Paper
                elevation={3}
                sx={{
                  p: 2,
                  zIndex: 1300,
                  borderRadius: 2,
                  position: 'absolute',
                  top: { lg: '100px', xs: '200px', sm: '150px', md: '150px' },
                  right: '25px',
                  width: { xs: '284px', sm: '320px', md: '280px' },
                  maxWidth: '320px',
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontFamily: 'Open Sans',
                      fontWeight: 600,
                      color: '#0b85c8',
                      fontSize: { xs: '13px', sm: '14px', md: '15px' },
                    }}
                  >
                    Customize Columns
                  </Typography>
                  <IconButton onClick={() => setOpencolspaper(false)} size="small">
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>

                <Box sx={{ mb: 1 }}>
                  <Button
                    variant="text"
                    onClick={() => {
                      const allSelected = columns.every(column => !column.hide);

                      if (allSelected) {
                        const updatedColumns = columns.map(column => ({ ...column, hide: true }));
                        setColumns(updatedColumns);
                        setColumnOrder([]);
                      } else {
                        const updatedColumns = columns.map(column => ({ ...column, hide: false }));
                        setColumns(updatedColumns);
                        setColumnOrder(columns.map(column => column.field));
                      }
                    }}
                    sx={{
                      fontFamily: 'Open Sans',
                      fontSize: { xs: '11px', sm: '12px', md: '13px' },
                      textTransform: 'none',
                      color: '#0b85c8',
                      p: 0,
                      minWidth: 'auto',
                      '&:hover': {
                        backgroundColor: 'transparent',
                        textDecoration: 'underline'
                      }
                    }}
                  >
                    {columns.every(column => !column.hide) ? 'Unselect All' : 'Select All'}
                  </Button>
                </Box>

                <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                  {columns.map((column) => (
                    <Box key={column.field} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Checkbox
                        checked={!column.hide}
                        onChange={(e) => {
                          const updatedColumns = columns.map((col) =>
                            col.field === column.field ? { ...col, hide: !e.target.checked } : col
                          );
                          setColumns(updatedColumns);
                          if (e.target.checked) {
                            setColumnOrder((prev) => {
                              if (!prev.includes(column.field)) {
                                return [...prev, column.field];
                              }
                              return prev;
                            });
                          } else {
                            setColumnOrder((prev) => prev.filter(field => field !== column.field));
                          }
                        }}
                        sx={{ mr: 1, p: 0.5 }}
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Open Sans',
                          fontSize: { xs: '12px', sm: '13px', md: '14px' },
                        }}
                      >
                        {column.headerName || column.field}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            )}
          </Box>
        </Box>
      </Box>


      <ReusableTable
        rows={filteredClients}
        columns={filteredColumns}
        onEdit={handleEdit}
        onDelete={handleDelete}
        pdf={pdf}
        onPdf={maildialogbox}
        editicon={editicon}
        deleteicon={deleteiocn}
        onApplyFilters={(activeFilters) => {
          setAppliedFilters(activeFilters);
        }}
        onPaginationChange={handlePaginationChange}
        totalrows={totalrows}
        onSelectionChange={(ids) => setSelectedIds(ids)}

      />
      <Dialog open={openDialog} maxWidth="md" fullWidth>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
          <DialogTitle sx={{ fontFamily: 'Open Sans', p: 2, textAlign: 'center', backgroundColor: '#f0f9ff', color: '#0b85c8', fontSize: { lg: '20px', xs: '15px' }, margin: 'auto' }}>
            {editingId ? 'Edit Client Details' : 'Add New Client to CRM'}
          </DialogTitle>
          <IconButton onClick={() => setOpenDialog(false)} sx={{ color: '#fff' }}>
            <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: "24px", borderRadius: 2, mr: 2 }} />
          </IconButton>
        </Box>

        <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', mt: -1, justifyContent: 'center' }}>
          <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Client Details</Typography>
            <Box sx={{ px: { lg: 2 }, position: 'relative' }}>
              <Autocomplete
                freeSolo
                options={leadCompanies.map(lead => lead.lead_name)}
                value={formData.clientName}
                onChange={(event, newValue) => {
                  setFormData(prev => ({ ...prev, clientName: newValue || '' }));
                  if (newValue) {
                    const selectedLead = leadCompanies.find(lead => lead.lead_name === newValue);
                    if (selectedLead) {
                      finalFollowup(selectedLead.id);
                    } else {
                      setIsLeadSelected(false);
                      setSelectedServices([]);
                      setFormData(prev => ({
                        ...prev,
                        companyid: companyid,
                        clientName: '',
                        contactPerson: '',
                        email: '',
                        phone: '',
                        alternateContact: '',
                        streetAddress: '',
                        city: '',
                        state: '',
                        postalCode: '',
                        country: '',
                        assignedTo: '',
                        notes: '',
                        discount: '',
                        amountToPay: '',
                        paymentTerms: '',
                        preferredPayment: '',
                        negotiate: 'No',
                        taxOption: 'including',
                        roundOff: null,
                        original_taxableAmount: 0,
                        original_taxAmount: 0,
                        original_totalAmount: 0,
                        revised_taxableAmount: 0,
                        revised_taxAmount: 0,
                        revised_totalAmount: 0,
                        revisedAmounts: []
                      }));
                      setNegotiate('No');
                      setTaxOption('including');
                      setRoundOff(0);
                      setNewDiscount(0);
                      setSelectedLeadDiscount(0);
                    }
                  } else {
                    setIsLeadSelected(false);
                    setSelectedServices([]);
                    setFormData(prev => ({
                      ...prev,
                      companyid: companyid,
                      clientName: '',
                      contactPerson: '',
                      email: '',
                      phone: '',
                      alternateContact: '',
                      streetAddress: '',
                      city: '',
                      state: '',
                      postalCode: '',
                      country: '',
                      assignedTo: '',
                      notes: '',
                      discount: '',
                      amountToPay: '',
                      paymentTerms: '',
                      preferredPayment: '',
                      negotiate: 'No',
                      taxOption: 'including',
                      roundOff: null,
                      original_taxableAmount: 0,
                      original_taxAmount: 0,
                      original_totalAmount: 0,
                      revised_taxableAmount: 0,
                      revised_taxAmount: 0,
                      revised_totalAmount: 0,
                      revisedAmounts: []
                    }));
                    setNegotiate('No');
                    setTaxOption('including');
                    setRoundOff(0);
                    setNewDiscount(0);
                    setSelectedLeadDiscount(0);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Client Name"
                    onChange={(e) => setFormData(prev => ({ ...prev, clientName: e.target.value }))}
                    fullWidth
                    size="small"
                    error={!!errors.clientName}
                    helperText={errors.clientName}
                  />
                )}
              />
            </Box>
          </Box>

          {/* Personal Details Section */}
          <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
            <Typography fontWeight={600} mb={1} mt={1} ml={2} sx={{ fontFamily: 'Open Sans' }}>Personal Details</Typography>
            <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
              <TextField
                label="Contact Person"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.contactPerson}
                helperText={errors.contactPerson}
              />
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.email}
                helperText={errors.email}
              />
              <TextField
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.phone}
                helperText={errors.phone}
              />
              <TextField
                label="Alternate Contact"
                name="alternateContact"
                value={formData.alternateContact}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
              />
              <TextField
                label="Tax ID"
                name="taxId"
                value={formData.taxId}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.taxId}
                helperText={errors.taxId}
              />
              <TextField
                label="Street Address"
                name="streetAddress"
                value={formData.streetAddress}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.streetAddress}
                helperText={errors.streetAddress}
              />
              <TextField
                select
                label="Country"
                name="country"
                value={formData.country}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.country}
                helperText={errors.country}
              >
                <MenuItem value="" disabled>Select Country</MenuItem>
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                disabled={!formData.country}
                error={!!errors.state}
                helperText={errors.state}
              >
                <MenuItem value="" disabled>Select State</MenuItem>
                {states
                  .filter(state => state.country_id === parseInt(formData.country))
                  .map((state) => (
                    <MenuItem key={state.id} value={state.id}>
                      {state.name}
                    </MenuItem>
                  ))}
              </TextField>
              <TextField
                select
                label="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.city}
                helperText={errors.city}
              >
                <MenuItem value="" disabled>Select City</MenuItem>
                {cities
                  .filter(city => city.state_id === parseInt(formData.state))
                  .map((city) => (
                    <MenuItem key={city.id} value={city.id}>
                      {city.name}
                    </MenuItem>
                  ))}
              </TextField>
              <TextField
                label="Postal Code"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                error={!!errors.postalCode}
                helperText={errors.postalCode}
              />
            </Grid>
          </Box>
          <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Billing Details</Typography>
            <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
              {!isLeadSelected && (
                <TextField
                  select
                  label="Opted Services"
                  name="optedService"
                  value=""
                  onChange={handleServiceSelect}
                  fullWidth
                  size="small"
                  sx={{ width: { xs: '100%', sm: '100%', lg: '96%' } }}
                >
                  {services.map(service => (
                    <MenuItem key={service.id} value={service.service_name}>{service.service_name}</MenuItem>
                  ))}
                </TextField>
              )}



              {(isLeadSelected || selectedServices.length > 0) && (
                <TableContainer component={Paper} sx={{ width: '96%', mt: 2, mb: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', textAlign: 'center' }}>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>S.No.</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Service Name</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Original Duration</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Start Date</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>End Date</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Opted Duration</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Price/Day</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Tax</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Total</TableCell>
                        <TableCell sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', textAlign: 'center' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedServices.map((service, index) => {
                        const pricePerDay = (parseFloat(service.base_price) / parseInt(service.original_duration)).toFixed(2);
                        return (
                          <TableRow key={service.id} sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', textAlign: 'center' }}>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{index + 1}</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.service_name}</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.original_duration} days</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                  disabled={isLeadSelected}
                                  value={service.start_date}
                                  onChange={(date) => handleServiceDateChange(index, 'start_date', date)}
                                  format="dd/MM/yyyy"
                                  slotProps={{
                                    textField: {
                                      size: 'small',
                                      error: !!errors[`serviceStartDate_${index}`],
                                      helperText: errors[`serviceStartDate_${index}`],
                                      sx: {
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                          height: 36,
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '8px 10px',
                                          height: '20px',
                                        },
                                      },

                                    }
                                  }}
                                />
                              </LocalizationProvider>
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                  value={service.end_date}
                                  disabled={isLeadSelected}
                                  onChange={(date) => handleServiceDateChange(index, 'end_date', date)}
                                  format="dd/MM/yyyy"
                                  slotProps={{
                                    textField: {
                                      size: 'small',
                                      error: !!errors[`serviceEndDate_${index}`],
                                      helperText: errors[`serviceEndDate_${index}`],
                                      sx: {
                                        width: '100%',
                                        '& .MuiInputBase-root': {
                                          height: 36,
                                        },
                                        '& .MuiInputBase-input': {
                                          padding: '8px 10px',
                                          height: '20px',
                                        }
                                      }
                                    }
                                  }}
                                />
                              </LocalizationProvider>
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>
                              {service.start_date && service.end_date ?
                                `${Math.ceil((new Date(service.end_date) - new Date(service.start_date)) / (1000 * 60 * 60 * 24)) + 1} days` :
                                'N/A'}
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{pricePerDay}</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.tax_rate}%</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>{service.total_amount}</TableCell>
                            <TableCell sx={{ fontFamily: 'Open Sans' }}>
                              <IconButton onClick={() => removeService(service.id)}>
                                <DeleteIcon color="error" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              <Box sx={{ width: '96%' }}>
                {selectedServices.length > 0 &&
                  <Box sx={{ justifyContent: 'left', width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3 }}>
                      <Box sx={{ textAlign: 'right' }}>Taxable Amount : </Box>
                      <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                        {formData.original_taxableAmount.toFixed(2)}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3, mb: 1 }}>
                      <Box sx={{ textAlign: 'right' }}>Tax Amount : </Box>
                      <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                        {formData.original_taxAmount.toFixed(2)}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5, mr: 3, mb: 1, mt: -1 }}>
                      <Box sx={{ textAlign: 'right' }}> Grand Total: </Box>
                      <Box sx={{ fontFamily: 'Open Sans', textAlign: 'right', width: '100px' }}>
                        {formData.original_totalAmount.toFixed(2)}
                      </Box>
                    </Box>
                  </Box>}
                <Box sx={{ p: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                  {selectedServices.length > 0 &&
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <FormControl component="fieldset">
                        <FormLabel sx={{ fontSize: '12px', fontWeight: 600 }}>Do you want to negotiate?</FormLabel>
                        <RadioGroup
                          row
                          value={negotiate}
                          onChange={(e) => {
                            setNegotiate(e.target.value);
                            setFormData({ ...formData, negotiate: e.target.value });
                          }}
                        >
                          <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                        </RadioGroup>
                      </FormControl>
                    </Box>}

                  {(selectedServices.length > 0 && negotiate === 'Yes') && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <FormControl component="fieldset">
                        <FormLabel sx={{ fontSize: '12px', fontWeight: 600 }}>Tax Option</FormLabel>
                        <RadioGroup
                          row
                          value={taxOption}
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setTaxOption(newValue);
                            setFormData(prev => ({
                              ...prev,
                              taxOption: newValue
                            }));
                          }}
                        >
                          <FormControlLabel value="including" control={<Radio size="small" />} label="Including Tax" />
                          <FormControlLabel value="excluding" control={<Radio size="small" />} label="Excluding Tax" />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  )}

                  {(selectedServices.length > 0 && negotiate === 'Yes') && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      {/* <TextField
                        label="Discount (%)"
                        value={newDiscount}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setNewDiscount(newValue);
                          setFormData(prev => ({
                            ...prev,
                            discount: parseFloat(newValue) || 0
                          }));
                        }}
                        type="number"
                        size="small"
                        sx={{ width: '150px' }}
                      /> */}
                      <TextField
                        label="Round Off Amount"
                        value={formData.roundOff}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setFormData(prev => ({
                            ...prev,
                            roundOff: newValue === '' ? 0 : parseFloat(newValue) || 0
                          }));
                        }}
                        type="number"
                        size="small"
                        sx={{ width: '150px' }}
                      />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                          Amount to Pay: {formData.revised_totalAmount}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {(selectedServices.length > 0 && negotiate === 'Yes') && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, fontFamily: 'Open Sans', textAlign: 'center' }}>
                        Summary
                      </Typography>
                      <TableContainer component={Paper} sx={{ backgroundColor: '#f5f5f5', boxShadow: 'none' }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 'bold', fontSize: '12px' }}>
                                Description
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 'bold', fontSize: '12px', textAlign: 'right' }}>
                                Amount
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                Original Taxable Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                {formData.original_taxableAmount.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                Original Tax Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                {formData.original_taxAmount.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                Original Total Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                {formData.original_totalAmount.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                Revised Taxable Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                {formData.revised_taxableAmount.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px' }}>
                                Revised Tax Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', textAlign: 'right' }}>
                                {formData.revised_taxAmount.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', fontWeight: 'bold' }}>
                                Final Total Amount
                              </TableCell>
                              <TableCell sx={{ fontFamily: 'Open Sans', fontSize: '12px', fontWeight: 'bold', textAlign: 'right' }}>
                                {formData.revised_totalAmount}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                </Box>
              </Box>
              <TextField
                select
                label="Payment Terms"
                name="paymentTerms"
                value={formData.paymentTerms}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%', md: '49%' } }}
              >
                {paymentTermsData.map(opt => (
                  <MenuItem key={opt.id} value={opt.id}>{opt.value}</MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Preferred Payment"
                name="preferredPayment"
                value={formData.preferredPayment}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '45%', md: '49%' } }}
              >
                {preferredPaymentData.map(opt => (
                  <MenuItem key={opt.id} value={opt.id}>{opt.value}</MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="Assigned To"
                name="assignedTo"
                value={formData.assignedTo}
                onChange={handleChange}
                fullWidth
                size="small"
                sx={{ width: { xs: '100%', sm: '100%', lg: '96%', md: '100%' } }}
              >
                {employeelist?.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.employee_name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Box>
          <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
            <Typography fontWeight={600} mb={1} mt={2} ml={2}>Notes</Typography>
            <TextField
              label="Notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              fullWidth
              size="small"
              multiline
              rows={3}
              sx={{ width: { lg: '96%' }, ml: { lg: 2 } }}
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2, backgroundColor: '#0b85c8', fontFamily: 'Open Sans', width: 'max-content', margin: 'auto' }}
              onClick={handleSubmit}
            >
              {getLeadButtonLabel(editingId, tab.value)}

            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog open={invoicedialog} onClose={closemaildialogbox}>
        <DialogTitle sx={{ textAlign: 'center', fontFamily: 'Open Sans', fontSize: '18px' }}>What would you like to do?</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={3} justifyContent="center" mt={1}>
            <Tooltip title="Send Mail">
              <IconButton
                color="primary"
                onClick={() => {
                  closemaildialogbox();
                  handleOpenEmailDialog(selectedClient);
                }}
              >
                <MailOutlineIcon />
              </IconButton>
            </Tooltip>
            {/* <Tooltip title="Whatsapp">
              <IconButton
                color="green"
                onClick={() => {
                  handlePdf(selectedClient, 'whatsapp');
                  closemaildialogbox();
                }}
              >
                <WhatsAppIcon sx={{ color: 'green' }} />
              </IconButton>
            </Tooltip> */}

            <Tooltip title="Preview PDF">
              <IconButton
                color="info"
                onClick={() => {
                  handlePdf(selectedClient, 'preview');

                  closemaildialogbox();
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Download PDF">
              <IconButton
                color="info"
                onClick={() => {
                  handlePdf(selectedClient, 'download');
                  setOpenPreview(false);
                }}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Cancel">
              <IconButton
                color="error"
                onClick={closemaildialogbox}
              >
                <CancelIcon />
              </IconButton>
            </Tooltip
            >
          </Stack>
        </DialogContent>
      </Dialog>


      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        fullWidth
        maxWidth="md"
        sx={{ '& .MuiDialog-paper': { borderRadius: 2, overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ fontFamily: 'Open Sans', textAlign: 'center', color: '#0b85c8', backgroundColor: '#f0f9ff' }}>
          Invoice Preview
        </DialogTitle>
        <DialogContent sx={{ height: '80vh', padding: 0, backgroundColor: '#f0f9ff', overflowY: 'auto' }}>
          {previewUrl && (
            <Box
              className="a4-page"
              sx={{
                width: "210mm",
                height: "297mm",
                margin: "auto",
                backgroundImage: `url(${previewUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                boxShadow: "0 0 6px rgba(0,0,0,0.3)",
                fontFamily: "Times New Roman, Times, serif",
                color: "#000",
                padding: "20mm",
                boxSizing: "border-box",
                position: "relative",
              }}
            >

              {/* Invoice Title */}
              <Typography
                sx={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginTop: '20mm',
                }}
              >
                Estimation Invoice
              </Typography>

              {/* Lead Details */}
              <Box sx={{ marginTop: '20mm', display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                  <Typography sx={{ fontSize: '12px' }}>To:</Typography>
                  <Typography sx={{ fontSize: '12px' }}>{selectedClient.client_name || '-'}</Typography>
                  <Typography sx={{ fontSize: '12px' }}>{selectedClient?.contact_person || '-'}</Typography>
                  <Typography sx={{ fontSize: '12px' }}>{selectedClient?.email || '-'}</Typography>
                  <Typography sx={{ fontSize: '12px' }}>{selectedClient?.phone || '-'}</Typography>
                </Box>
                <Typography sx={{ fontSize: '12px' }}>
                  Date: {new Date().toLocaleDateString()}
                </Typography>
              </Box>

              {/* Services Table */}
              <TableContainer
                component={Paper}
                sx={{ marginTop: '10mm', width: '100%', backgroundColor: 'transparent', boxShadow: 'none' }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {['Service', 'Start Date', 'End Date', 'Days', 'Amount'].map((header, index) => (
                        <TableCell
                          key={header}
                          sx={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            backgroundColor: '#f0f9ff',
                            padding: '2mm',
                            width: index === 0 ? '28.5%' : index === 4 ? '19%' : '14.5%',
                            textAlign: index === 4 ? 'right' : 'left',
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedClient?.services?.map((service, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                          {service.service_name || '-'}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                          {service.start_date?.split('T')[0] || '-'}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                          {service.end_date?.split('T')[0] || '-'}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', padding: '2mm' }}>
                          {service.duration || '-'}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', padding: '2mm', textAlign: 'right' }}>
                          {parseFloat(service.total_amount || 0).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Totals */}
              <Box sx={{ marginTop: '10mm', textAlign: 'right' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                  Subtotal: {selectedClient?.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0).toFixed(2)}
                </Typography>
                <Typography sx={{ fontSize: '12px', fontWeight: 'bold', marginTop: '2mm' }}>
                  Discount ({selectedClient?.discount || 0}%): {((selectedClient?.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0) * (parseFloat(selectedClient?.discount || 0) / 100))).toFixed(2)}
                </Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 'bold', marginTop: '2mm' }}>
                  Total: {(selectedClient?.services?.reduce((sum, s) => sum + parseFloat(s.total_amount || 0), 0) * (1 - parseFloat(selectedClient?.discount || 0) / 100)).toFixed(2)}
                </Typography>
              </Box>
            </Box>
            // </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', padding: 2 }}>
          <Button
            variant="contained"
            color='success'
            startIcon={<DownloadIcon />}
            onClick={() => {
              handlePdf(selectedClient, 'download');
              setOpenPreview(false);
            }}>
            Download
          </Button>

          {/* <Tooltip title="Download PDF">
                        <IconButton
                          color="success"
      
                        >
                          <DownloadIcon />
                        </IconButton>
                      </Tooltip> */}
        </DialogActions>


      </Dialog>
      <Dialog
        open={openEmailDialog}
        onClose={handleCloseEmailDialog}
        maxWidth="sm"
        fullWidth
        sx={{ '& .MuiDialog-paper': { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ fontFamily: 'Open Sans', textAlign: 'center', color: '#0b85c8', backgroundColor: '#f0f9ff' }}>
          Compose Email
        </DialogTitle>
        <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', pt: 2 }}>
          <TextField
            label="Subject"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <TextField
            label="Email Content"
            value={emailContent}
            onChange={(e) => setEmailContent(e.target.value)}
            fullWidth
            multiline
            rows={6}
            size="small"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', backgroundColor: '#f0f9ff', pb: 2 }}>
          <Button
            variant="contained"
            startIcon={<SendIcon />}
            onClick={handleSendEmail}
            sx={{ backgroundColor: '#0b85c8', fontFamily: 'Open Sans' }}
          >
            Send Email
          </Button>
          <Button
            variant="outlined"
            startIcon={<CancelIcon />}
            onClick={handleCloseEmailDialog}
            sx={{ fontFamily: 'Open Sans', color: '#0b85c8', borderColor: '#0b85c8' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>


    </Container>
  );
}
